<template>
  <div class="p-contentrewrite-form">
    <div class="p-contentrewrite-form__inner">
      <div class="p-contentrewrite-form__item">
        <p class="p-contentrewrite-form__legend">キーワード</p>
        <div class="c-alertPos">
          <Input
            v-model="params.keyword"
            placeholder="（例）seo対策"
            :disabled="isDisablednInput"
            :class="{ alert: isEdited.keyword && error.keyword }"
            v-focus
            @focusout="focusoutKeyword"
          />
          <Alert v-if="isEdited.keyword && error.keyword">{{
            error.keyword
          }}</Alert>
        </div>
      </div>
      <div class="p-contentrewrite-form__item">
        <p class="p-contentrewrite-form__legend">改善したいページのURL</p>
        <div class="c-alertPos">
          <Input
            v-model="params.url"
            placeholder="（例）https://example.co.jp/blog/"
            :disabled="isDisablednInput"
            :class="{ alert: isEdited.url && error.url }"
            @focusout="focusoutUrl"
          />
          <Alert v-if="isEdited.url && error.url">{{ error.url }}</Alert>
        </div>
      </div>
      <div class="p-contentrewrite-form__btn c-alertPos">
        <Alert v-if="isEdited.keyword && isEdited.url && isUsageLimited">
          月間利用回数の上限に達しています。
        </Alert>
        <ButtonRectangle
          priority="high"
          size="large"
          :isLoading="isProcessing"
          :disabled="isDisabledButton"
          @click="submit"
        >
          改善する
        </ButtonRectangle>
      </div>
    </div>
    <div class="p-contentrewrite-form-guide">
      <IconDefault type="informationCircle" :size="64" />
      <div class="p-contentrewrite-form-guide__inner">
        <p class="p-contentrewrite-form-guide__title">
          AIリライト提案はBeta版としてご利用いただけます。<br />ご利用いただいたみなさまからのフィードバックを基に、本格的な機能実装を今後予定しております。
        </p>
        <p>下記をご了承の上、ご活用いただけますと幸いです。</p>
        <ul class="c-list--disc">
          <li>
            同じキーワードとURLで複数回利用すると、その回数分が消化されますのでご注意ください。
          </li>
          <li>AIからの提案内容の精度が十分でない場合がございます。</li>
          <li>
            過去の履歴は残りません。画面を離れる際は、テキストをダウンロードいただくことを推奨いたします。
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from '@/components/Alert';
import ButtonRectangle from '@/components/ButtonRectangle';
import IconDefault from '@/components/icon/IconDefault';
import Input from '@/components/Input';
import Amplitude from '@/amplitude';
import Validation from '@/validation';

export default {
  props: {
    isProcessing: {
      type: Boolean,
      required: false
    },
    isUsageLimited: {
      type: Boolean,
      required: false
    }
  },
  components: {
    Alert,
    ButtonRectangle,
    IconDefault,
    Input
  },
  data() {
    return {
      error: {
        keyword: '',
        url: ''
      },
      params: {
        keyword: '',
        url: ''
      },
      isEdited: {
        keyword: false,
        url: false
      }
    };
  },
  computed: {
    hasError() {
      return this.error.keyword || this.error.url ? true : false;
    },
    isDisablednInput() {
      return this.isUsageLimited || this.isProcessing;
    },
    isDisabledButton() {
      return this.isUsageLimited || this.isProcessing || this.hasError;
    }
  },
  watch: {
    'params.keyword': {
      handler(value) {
        const keyword = value.trim();
        this.error.keyword = new Validation()
          .input()
          .maxLength(255)
          .test(keyword);
        this.isEdited.keyword = keyword ? true : false;
      },
      immediate: true
    },
    'params.url': {
      handler(value) {
        const url = value.trim();
        this.error.url = new Validation()
          .input()
          .url()
          .test(url);
        this.isEdited.url = url ? true : false;
      },
      immediate: true
    }
  },
  methods: {
    focusoutKeyword() {
      this.params.keyword = this.$options.filters.normalizeAllSpaces(
        this.params.keyword
      );
    },
    focusoutUrl() {
      this.params.url = this.$options.filters.normalizeAllSpaces(
        this.params.url
      );
    },
    submit() {
      if (this.isDisabledButton) {
        return;
      }
      this.$emit('submit', this.params);
      Amplitude.postLogEvent('ClickContentRewriteBeta');
    }
  }
};
</script>
